import React, { PureComponent } from 'react';

// Components
import { Alert, Form, Modal, Row, Col, Input, Checkbox } from 'antd';
import { MODAL_SIZES } from '../../constants/modal';

class EditUser extends PureComponent {
    handleSubmit = () => {
        const { form } = this.props;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            const { onSubmit, selectedUser, onClose } = this.props;
            onSubmit(
                {
                    ...selectedUser,
                    ...values,
                    hasError: undefined,
                    helpers: undefined
                },
                selectedUser ? selectedUser.id : undefined
            )
                .then(() => {
                    onClose();
                })
                .catch(err => {
                    if (err.status === 400) {
                        form.setFields({
                            hasError: {
                                value: err && err.message
                            }
                        });
                    }
                });
        });
    };

    handleAlertClose = () => {
        const { form } = this.props;
        form.setFields({
            hasError: {
                value: undefined
            }
        });
    };

    render() {
        const { isShown, isLoading, selectedUser, form, onClose, msgs } = this.props;

        const { getFieldDecorator, getFieldValue } = form;

        return (
            <Modal
                key="admin-users-modal-add-or-edit"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.MEDIUM}
                title={`${msgs.users.editUser} - ${selectedUser.name} ${selectedUser.surename}`}
                onCancel={onClose}
                onOk={this.handleSubmit}
                cancelText={msgs.cancel}
                okText={msgs.users.editUser}
            >
                <Form>
                    {getFieldValue('hasError') && (
                        <Row>
                            <Col xs={24}>
                                <Alert
                                    message={getFieldValue('hasError')}
                                    type="error"
                                    showIcon
                                    closable
                                    onClose={this.handleAlertClose}
                                />
                            </Col>
                        </Row>
                    )}
                    <Row gutter={8}>
                        <Col xs={12}>
                            <Form.Item label={msgs.users.firstNameLabel}>
                                {getFieldDecorator('name', {
                                    initialValue: selectedUser.name ? selectedUser.name : undefined
                                })(<Input type="text" />)}
                            </Form.Item>
                        </Col>
                        <Col xs={12}>
                            <Form.Item label={msgs.users.lastNameLabel}>
                                {getFieldDecorator('surename', {
                                    initialValue: selectedUser.surename
                                        ? selectedUser.surename
                                        : undefined
                                })(<Input type="text" />)}
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item>
                                {getFieldDecorator('admin', {
                                    initialValue: selectedUser.admin ? selectedUser.admin : false,
                                    valuePropName: 'checked'
                                })(<Checkbox>{msgs.users.addUserAsAdmin}</Checkbox>)}
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item>
                                {getFieldDecorator('tester', {
                                    initialValue: selectedUser.tester ? selectedUser.tester : false,
                                    valuePropName: 'checked'
                                })(<Checkbox>{msgs.users.addUserAsTester}</Checkbox>)}
                            </Form.Item>
                        </Col>
                        <Col xs={24}>
                            <Form.Item>
                                {getFieldDecorator('installer', {
                                    initialValue: selectedUser.installer ? selectedUser.installer : false,
                                    valuePropName: 'checked'
                                })(<Checkbox>{msgs.users.addUserAsInstaller}</Checkbox>)}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
}

export default Form.create()(EditUser);
